import { render, staticRenderFns } from "./RecipientHla.vue?vue&type=template&id=2253c879"
import script from "./RecipientHla.vue?vue&type=script&lang=ts"
export * from "./RecipientHla.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/views/_locales/RecipientHla.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fhla%2FRecipientHla.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports